module.exports = __webpack_public_path__ + "img/jmgy.860381fc.jpg";